import React, { useContext } from "react";
import Layout from "layouts/LayoutMasterDetail";

import { StoreContext } from "shared/context/store-context";
import { paymentMethods } from "shared/util/types";

import ExpenseItem from "./ExpenseItem";

const ExpensesList = () => {
  const itemType = "expense";
  const listName = "main_expenses";

  const { expenses, schoolOptions, InsertExpense, DeleteExpense, UpdateExpense } = useContext(StoreContext);

  const pageItems = expenses;

  const listColumns = [
    {
      field: "school",
      headerName: "Kurum",
      width: 300,
      valueGetter: (params) =>
        schoolOptions.find((item) => item.value.toString() === params?.row?.school?.toString())?.label || "",
    },

    {
      field: "date",
      headerName: "Ödeme Tarihi",
      width: 200,
      //valueGetter: (params) => store.educationYearsOptions.find((item) => item.value.toString() === params.row.year.toString()).label
    },

    { field: "person", headerName: "Kişi/Kurum", width: 250 },
    { field: "amount", headerName: "Ücret", width: 150 },

    {
      field: "paymentMethod",
      headerName: "Ödeme Yöntemi",
      width: 150,
      valueGetter: (params) =>
        paymentMethods.find((item) => item.value.toString() === params.row.paymentMethod.toString()).label,
    },

    // { field: 'name', headerName: 'Hizmet Adı', width: 300 },
    // { field: 'serviceStartDate', headerName: 'Hizmet Başlangıç Tarihi', width: 200 },
    // { field: 'serviceEndingDate', headerName: 'Hizmet Bitiş Tarihi', width: 200 },
    // { field: 'amount', headerName: 'Meblağ', width: 200 },
  ];

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      SelectedItemComponent={ExpenseItem}
      NewItemComponent={ExpenseItem}
      DeleteItem={DeleteExpense}
      InsertItem={InsertExpense}
      UpdateItem={UpdateExpense}
      hideCreateNewItemWhenSelected={true}
    />
  );
};

export default ExpensesList;
